// Public read of the admin-managed home hero carousel.
import { useQuery } from "@tanstack/react-query";
import { fetchHeroCarousel, type HeroCarouselData } from "@/lib/hero-carousel-query";

export function useHeroCarousel(initialData?: HeroCarouselData) {
  return useQuery({
    queryKey: ["hero-carousel"],
    staleTime: 5 * 60 * 1000,
    ...(initialData ? { initialData } : {}),
    queryFn: fetchHeroCarousel,
  });
}
